import axios from "axios";
// config
// import { HOST_API_KEY } from '../config';
import { errorToast } from "./toastMessage";

// ----------------------------------------------------------------------
// console.log(process.env.REACT_APP_APP_BASE_URL)
const axiosInstance = axios.create({
  // baseURL: "https://deeppink-parrot-612114.hostingersite.com",
  baseURL: process.env.REACT_APP_APP_BASE_URL,
  // baseURL: "http://64.226.123.175:8081",
//  baseURL: process.env.REACT_APP_APP_BASE_URL,
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
    AuthenticatedProvider: localStorage.getItem("AuthenticatedProvider"),
    "Accept-Language": "ar",
  },
  // timeout: 4000,
});

axiosInstance.interceptors.response.use(
  (response) => {
    if (
      response.status === 200 &&
      (response.data.message === "Success" ||
        response.data.message === "تمت العملية بنجاح")
    ) {
      return response.data;
    } else if (
      response.status === 200 &&
      (response.data.message !== "Success" ||
        response.data.message !== "تمت العملية بنجاح")
    ) {
      return response.data;
    } else if (response.status === 200 && response.data.status !== 200) {
   
      return response.data;
    }
    return response.data;
  },
  (error) => {
    //console.log("aa", JSON.stringify(error, null, 2));
    /*if (error?.message === "Network Error") {
      alert("Network Error");
    }*/
    if (error.response.status === 401) {
    //  alert(error.response.statusText);
    } else if (error.response.status === 402) {
      throw error;
    } else if (
      error.response.status === 406 ||
      error.response.status === 422 ||
      error.response.status === 419
    ) {
      if (
        error.response.data.message === "" ||
        error?.response?.data?.data?.account_found_nd_profile_not_created
      ) {
      } else {
        // console.log(error.response.statusText);
        console.log(error.response.data.message);
        // alert(error.response.statusText);
      //  alert(error.response.data.message);
        // errorToast(error.response.statusText);
        errorToast(error.response.data.message);
      }
      throw error;
    } else {
      console.log(error.response.statusText);
  //    alert(error.response.statusText);
      throw errorToast(error.response.statusText);
    }
  }
);
export default axiosInstance;
